export default __webpack_public_path__ + "static/media/edit.bb0887ad.svg";